import Component from '@glimmer/component';
import { PrismIcon } from '@mylighthouse/prism-ember';
import type {
  IconColor,
  IconName,
} from '@mylighthouse/prism-ember/types/components/prism/icon';
import type { OverrideVariant } from 'lumen/utils/constants/pricing-assistant-constants';

interface HotelPricingAssistantOverrideIndicatorSignature {
  Args: {
    isDisabled?: boolean;
    /** PrismIcon @name: 'bullet' = manual/price-range, 'automation-off' = automation-pausing */
    variant?: OverrideVariant;
  };
}

export default class HotelPricingAssistantOverrideIndicator extends Component<HotelPricingAssistantOverrideIndicatorSignature> {
  get iconColor(): IconColor {
    if (this.args.isDisabled) {
      return 'disabled';
    }
    return this.args.variant === 'automation-off' ? 'warning' : 'info';
  }

  get iconName(): IconName {
    return this.args.variant ?? 'bullet';
  }

  <template>
    <PrismIcon
      @color={{this.iconColor}}
      @name={{this.iconName}}
      @size="small"
      data-test-id="override-icon"
    />
  </template>
}
